import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';

export function QuestionPage({ playerState, header, answer, setAnswer, answerBool, setAnswerBool, onSubmit, error, assignedLabel, lockRemaining }) {
  const question = playerState.currentQuestion;
  const options = question?.type === 'ABCD'
    ? ['A', 'B', 'C', 'D'].map((optionKey) => ({ value: optionKey, label: question.options[optionKey] }))
    : [
        { value: true, label: 'Točno' },
        { value: false, label: 'Netočno' }
      ];
  const hasSelection = question?.type === 'ABCD' ? !!answer : answerBool !== null;

  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h5">{playerState.currentRound?.title}</Typography>
      <Typography>KRUG {playerState.currentRoundIndex + 1} PITANJE {playerState.progress + 1}/{playerState.totalQuestions}</Typography>
      <Typography variant="h4">{question?.text}</Typography>
      <Typography>Odaberi točan odgovor:</Typography>
      <Stack spacing={1.5}>
        {options.map((option) => {
          const selected = question?.type === 'ABCD' ? answer === option.value : answerBool === option.value;
          return (
            <Button
              key={String(option.value)}
              variant={selected ? 'contained' : 'outlined'}
              color={selected ? 'primary' : 'inherit'}
              fullWidth
              onClick={() => {
                if (question?.type === 'ABCD') {
                  setAnswer(option.value);
                  return;
                }
                setAnswerBool(option.value);
              }}
              sx={{
                justifyContent: 'flex-start',
                py: 1.5,
                px: 2,
                borderWidth: 2,
                textTransform: 'none',
                fontSize: '1.1rem'
              }}
            >
              {option.label}
            </Button>
          );
        })}
      </Stack>
      {error && <Alert severity="error">{error}</Alert>}
      {lockRemaining > 0 && <Alert severity="warning">Pričekajte {lockRemaining} s prije novog pokušaja.</Alert>}
      <Button variant="contained" disabled={lockRemaining > 0 || !hasSelection} onClick={onSubmit}>Potvrdi odabir</Button>
    </PlayerCardLayout>
  );
}
